import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const actionButton = css`
  inset-block-end: ${spacing(-0.5)};
  position: sticky;
`
